import { render, staticRenderFns } from "./_.vue?vue&type=template&id=5cf43e0a"
import script from "./_.vue?vue&type=script&lang=js"
export * from "./_.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Sulu: require('/opt/iaravia.ru/node_modules/@razlet/sulu-sdk/src/components/index.vue').default})
